import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/price-frequencies/profile/loading';

export const Route = createFileRoute('/_private/settings/price-frequencies/$id')({
  pendingComponent: Loading,
});
